import { SchemaSection as SchemaSectionType } from '../../LandingPage.types'

interface SchemaSectionProps {
  section: SchemaSectionType
}

const SchemaSection = ({ section }: SchemaSectionProps) => {
  const { schema } = section
  return <script type="application/ld+json">{JSON.stringify(schema)}</script>
}

export default SchemaSection
